module.exports = __webpack_public_path__ + "img/UT0413.aca237e7.png";